import React from "react";

const Input = ({ label, type = "text", value, onChange, placeholder = "", required = false, style = {} }) => (
  <div style={{ marginBottom: 16 }}>
    {label && (
      <label style={{ display: "block", marginBottom: 6, fontWeight: 500, fontSize: 14, color: "#444" }}>
        {label}
      </label>
    )}
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      style={{
        width: "100%",
        padding: "10px 14px",
        border: "1.5px solid #e5e7eb",
        borderRadius: 8,
        fontSize: 14,
        boxSizing: "border-box",
        outline: "none",
        transition: "border-color 0.15s ease",
        background: "#fafafa",
        ...style,
      }}
      onFocus={(e) => (e.target.style.borderColor = "#6c63ff")}
      onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
    />
  </div>
);

export default Input;
